module.exports = __webpack_public_path__ + "static/media/exclamation@3x.09777eda.png";